import React, { useState, useCallback } from 'react';
import Gallery from 'react-photo-gallery';
import Carousel, { Modal, ModalGateway } from 'react-images';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import {arrayMoveImmutable} from 'array-move';
import PhotoGalleryItem from './components/PhotoGalleryItem';
import './styles.css';

const SortablePhoto = SortableElement(item => (
  <PhotoGalleryItem {...item} draggable={true} controls={false} />
));

const SortableGallery = SortableContainer(({ items }) => (
  <Gallery photos={items} renderImage={props => <SortablePhoto {...props} />} />
));

const PhotoGallery = props => {
  const { showAll, onDelete, isSortable, items, sortFunc, controls } = props;
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = useCallback((event, { index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    sortFunc(arrayMoveImmutable(items, oldIndex, newIndex));
  };

  const topFiveItems = items.slice(0, 5);

  if (items.length === 0) {
    return null;
  }

  return (
    <div
      className="photo-gallery"
      style={{
        minHeigth: topFiveItems.length > 0 ? '170px' : 'auto',
      }}
    >
      {isSortable ? (
        <SortableGallery items={items} onSortEnd={onSortEnd} axis={'xy'} />
      ) : (
        <>
          <Gallery
            photos={showAll ? items : topFiveItems}
            onClick={openLightbox}
            renderImage={props => (
              <PhotoGalleryItem
                {...props}
                index={props.index}
                controls={controls}
                onDelete={onDelete}
              />
            )}
          />
        </>
      )}

      <ModalGateway>
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox}>
            <Carousel
              currentIndex={currentImage}
              views={items.map(x => ({
                ...x,
                srcset: x.srcSet,
                caption: x.title,
              }))}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </div>
  );
};

export default PhotoGallery;
